import { requestJson } from "../../service/api";

/** GET /invoice/:id/status — returns { ok, status, body } per pack §5.3 */
const fetchInvoicePaymentStatus = async (invoiceId) =>
  requestJson("get", `/invoice/${invoiceId}/status`);

export default fetchInvoicePaymentStatus;
